export const CROWS_SEARCH_ADJUSTMENTS = 5248;
export const TEST_GROUP = 2;

export const MAX_RECENT = 3;
export const MAX_TRENDING = 9;
export const TYPING_INTERVAL_MS = 40;
export const TYPING_HOLD_MS = 3000;
